module.exports = __webpack_public_path__ + "static/media/gallery-4.cc45661b.jpg";